export default __webpack_public_path__ + "static/media/setting_active.f3ab2242.svg";